import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import PersonalizeOnEveryChannelImage from './PersonalizeOnEveryChannelImage'

const copy = {
  heading: `Personalize on every channel`,
  description: `Build the experiences your customers want by activating data + intelligence through the complete customer journey.`,
}

const link = {
  text: `Explore Twilio Engage`,
  url: `/product/twilio-engage/`,
}

const PersonalizeOnEveryChannel = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionBase variant="2Col" reverse={true}>
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </SectionCopy>
      <Section.Contents>
        <PersonalizeOnEveryChannelImage />
      </Section.Contents>
    </SectionBase>
  )
}

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default PersonalizeOnEveryChannel
